import { render, staticRenderFns } from "./zsXiangQing.vue?vue&type=template&id=14dbe87f&scoped=true&"
import script from "./zsXiangQing.vue?vue&type=script&lang=js&"
export * from "./zsXiangQing.vue?vue&type=script&lang=js&"
import style0 from "./zsXiangQing.vue?vue&type=style&index=0&id=14dbe87f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dbe87f",
  null
  
)

export default component.exports